import React, { useState } from "react";
import { Container } from "react-bootstrap";
import about1 from "../../assets/Images/Blogs/pexels-pixabay-259756.jpg";
import about2 from "../../assets/Images/Blogs/pexels-vika-glitter-392079-1648771.jpg";
import about3 from "../../assets/Images/Blogs/ai-generated-8678477_1280.png";
import about4 from "../../assets/Images/Blogs/ai-generated-8525194_1280.png";
import { useIsMobile } from "../../utils/responsive";
export default function Section1() {
  const [hoveredImage, setHoveredImage] = useState(null);
  const isMobile = useIsMobile();

  const handleImageHover = (index) => {
    setHoveredImage(index);
  };

  return (
    <Container fluid className="p-0">
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}

        {/* Text Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
            // borderLeft: "1px solid black",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          // className="p-5"
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <p className="body-lg m-0">
              <span className="accent-text">Color theory&nbsp;</span>
              involves the study of hues and how to use them in harmony. It's
              helpful in design because it informs a palette that work well
              together. These choices play a key role in the overall environment
              of a home because color can influence moods, feelings and even
              increase how much sleep you get. Color is a fundamental building
              block of interior design. But beyond imagining how colors will
              look together and work in your home, it's important to consider
              how they make you feel. Color psychology is the theory that colors
              can affect how you feel, think and act.
            </p>
          </div>
        </div>
        {/* Image Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
            padding: "0",
            overflow: "hidden",
          }}
        >
          <div
            className="image-container"
            style={{
              height: "100%",
              minHeight: isMobile ? "400px" : "600px",
              display: "flex",
              flexDirection: "row",
              gap: "0",
              transition: "all 0.5s ease",
            }}
            onMouseEnter={() => handleImageHover(1)}
            onMouseLeave={() => handleImageHover(null)}
          >
            <img
              src={about1}
              alt="Profile 1"
              className="image-cover-full-responsive"
              style={{
                transition: "all 0.5s ease",
                transform: hoveredImage === 1 ? "scale(1.05)" : "scale(1)",
                filter:
                  hoveredImage === 1 ? "brightness(1.05)" : "brightness(1)",
              }}
            />
          </div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}

        {/* Image Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
            // borderLeft: "1px solid black",
            padding: "0",
            overflow: "hidden",
          }}
        >
          <div
            className="image-container"
            style={{
              height: "100%",
              minHeight: isMobile ? "400px" : "600px",
              display: "flex",
              flexDirection: "row",
              gap: "0",
              transition: "all 0.5s ease",
            }}
            onMouseEnter={() => handleImageHover(2)}
            onMouseLeave={() => handleImageHover(null)}
          >
            <img
              src={about2}
              alt="Profile 1"
              className="image-cover-full-responsive"
              style={{
                transition: "all 0.5s ease",
                transform: hoveredImage === 2 ? "scale(1.05)" : "scale(1)",
                filter:
                  hoveredImage === 2 ? "brightness(1.05)" : "brightness(1)",
              }}
            />
          </div>
        </div>
        {/* Text Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          // className="p-5"
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <p className="body-lg m-0">
              <span className="accent-text">The newest trend&nbsp;</span>
              that was explored in 2020 was the Color Blocking trend. It is an
              adventurous route to using colors in any space and not meant for
              the light hearted. But it's the simplest way of defining a wall or
              a space by simple use of colors. What is the 60-30-10 Rule? It's a
              classic decor rule that helps create a color palette for a space.
              It states that 60% of the room should be a dominant color, 30%
              should be the secondary color or texture and the last 10% should
              be an accent. 60% of a room is comprised of wall space and large
              anchor pieces. 30% of a room is accent furniture, area rugs, wood
              trim, textiles, etc. 10% is variety via decor, artwork and smaller
              items.
            </p>
          </div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        {/* Text Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
            // borderLeft: "1px solid black",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          // className="p-5"
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <p className="body-lg m-0">
              <span className="accent-text">
                Contrasting interior elements&nbsp;
              </span>
              such as plain painted walls with vibrant patterned wallpaper or
              bright shades produce harmonious diversity and pace in a room.
              Selecting a dominant color acts as the foundation of your room so
              it's key to get this right.
            </p>
          </div>
        </div>
        {/* Image Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
            padding: "0",
            overflow: "hidden",
          }}
        >
          <div
            className="image-container"
            style={{
              height: "100%",
              minHeight: isMobile ? "400px" : "600px",
              display: "flex",
              flexDirection: "row",
              gap: "0",
              transition: "all 0.5s ease",
            }}
            onMouseEnter={() => handleImageHover(3)}
            onMouseLeave={() => handleImageHover(null)}
          >
            <img
              src={about3}
              alt="Profile 1"
              className="image-cover-full-responsive"
              style={{
                transition: "all 0.5s ease",
                transform: hoveredImage === 3 ? "scale(1.05)" : "scale(1)",
                filter:
                  hoveredImage === 3 ? "brightness(1.05)" : "brightness(1)",
              }}
            />
          </div>
        </div>

        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
      <div
        className="d-flex justify-content-center"
        style={{
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}

        {/* Image Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
            // borderLeft: "1px solid black",
            padding: "0",
            overflow: "hidden",
          }}
        >
          <div
            className="image-container"
            style={{
              height: "100%",
              minHeight: isMobile ? "400px" : "600px",
              display: "flex",
              flexDirection: "row",
              gap: "0",
              transition: "all 0.5s ease",
            }}
            onMouseEnter={() => handleImageHover(4)}
            onMouseLeave={() => handleImageHover(null)}
          >
            <img
              src={about4}
              alt="Profile 1"
              className="image-cover-full-responsive"
              style={{
                transition: "all 0.5s ease",
                transform: hoveredImage === 4 ? "scale(1.05)" : "scale(1)",
                filter:
                  hoveredImage === 4 ? "brightness(1.05)" : "brightness(1)",
              }}
            />
          </div>
        </div>
        {/* Text Column */}
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          // className="p-5"
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <p className="body-lg m-0">
              <span className="accent-text">
                The secondary (30%) color&nbsp;
              </span>
              adds contrast to the room. Take one piece – whether it be your
              favourite cushion or singular flick of color in a painting on your
              wall – and play around with materials and color, exploring the
              possibilities of clashing and coordinating to let the piece tell
              its story.
            </p>

            <p className="body-lg m-0">
              This color can be used in furniture, curtains, area rugs, bedding
              or an accent wall. Choose accessories that complement the dominant
              color palette of a room. This will help pull a room together and
              create a sense of cohesiveness.
            </p>
          </div>
        </div>

        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
